import store from '@/store';
import RouteKey from '@/common/RouteKey';
import SessionManager from '@/common/storage/SessionManager';
import { SESSION_HAS_SHOW_VERIFY } from '@/common/storage/StorageKey';
import router from '@/router';

export default {
  transferNext: function() {
    // 向后兼容老版本
    SessionManager.setItem(SESSION_HAS_SHOW_VERIFY, true);
    let userState = store.state.open.user;
    if (!userState.isVerifyPhone) {
      return router.transfer(RouteKey.OPEN_VERIFY_PHONE);
    }
    if (!userState.isVerifyMail) {
      return router.transfer(RouteKey.OPEN_VERIFY_MAIL);
    }
    router.transfer(RouteKey.OPEN_VERIFY_SUCCESS);
  }
};



// WEBPACK FOOTER //
// ./src/components/open/common/ValidateTransferHelper.js